import { getRequestHeader } from 'h3'
import { getLocalDevSfccContext } from '~/utils/local-dev-sfcc'
import { isFrenchPath, resolveRequestMarket } from '~/utils/requestMarket'

// Returned, not thrown, and fatal: otherwise the router aborts quietly and the page still renders.
const notFound = () => createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true })

const resolveSiteId = (hostname: string | undefined, organizationId?: string, siteId?: string) =>
  getLocalDevSfccContext(hostname, organizationId, { siteId })?.siteId

export default defineNuxtRouteMiddleware(async (to) => {
  const i18n = useNuxtApp().$i18n
  const config = useRuntimeConfig()

  // Decided on the server: the browser can't read DOMAIN_EN_* so it can't recognise local and staging hosts.
  const isCaSite = useState<boolean>('isCaSite')

  if (import.meta.client) {
    if (isFrenchPath(to.path)) {
      if (!isCaSite.value) {
        return notFound()
      }
      await i18n.setLocale('fr') // Set to French - Canada
    }
    return
  }

  const event = useRequestEvent()
  if (!event) {
    throw new Error('Request event is undefined')
  }

  const hostname = getRequestHeader(event, 'cf-worker') || getRequestHeader(event, 'host')
  const siteId = resolveSiteId(
    hostname,
    config.public.SFCC_ORGANIZATION_ID || process.env.SFCC_ORGANIZATION_ID,
    config.public.SFCC_SITE_ID || process.env.SFCC_SITE_ID,
  )
  const market = resolveRequestMarket(hostname, siteId)
  isCaSite.value = market === 'CA'

  // Set i18n locale based on the cf-worker header or local dev portless host.
  if (market === 'CA') {
    await i18n.setLocale(isFrenchPath(to.path) ? 'fr' : 'en-CA')
  } else if (market === 'NZ') {
    await i18n.setLocale('en-NZ')
  }

  // i18n generates the /fr routes on every domain and falls back to the path prefix when the host is
  // unrecognised, so French would otherwise render on AU and NZ.
  if (isFrenchPath(to.path) && market !== 'CA') {
    // i18n will have taken fr from the prefix, so the 404 page needs this site's English.
    if (market !== 'NZ') {
      await i18n.setLocale('en-AU')
    }
    return notFound()
  }
})
